// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { footerContainerStyles } from "@sc/Overrides/Widgets/Footer/FooterContainer";
import { DivWrapper } from "@sc/XDL/constants";
import { color, layoutContainer, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

const sectionStyles = css`
    display: flex;
    justify-content: space-between;
    gap: 22px;
`;

footerContainerStyles.container = {
    css: css`
        ${({ isCheckoutPage }: any) => (isCheckoutPage ? "padding: 16px;" : "padding: 24px 16px 16px;")}
        ${layoutContainer}
    `,
};

footerContainerStyles.applicationWrapper = {
    css: css`
        display: flex;
    `,
};

footerContainerStyles.topSection = {
    css: css`
        ${sectionStyles}
        padding-bottom: 24px;
        margin-bottom: 24px;
        border-bottom: 1px solid ${color("common.border")};
        align-items: center;
        ${xScreen("lte", "md")} {
            flex-direction: column;
            gap: 24px;
            align-items: start;
        }
        ${xScreen("lte", "sm")} {
            margin-bottom: 22px;
        }
    `,
};

footerContainerStyles.middleSection = {
    css: css`
        ${sectionStyles}
        margin-bottom: 24px;
        ${xScreen("lte", "md")} {
            flex-direction: column;
            gap: 24px;
        }
        ${xScreen("lte", "sm")} {
            margin-bottom: 16px;
        }
    `,
};

footerContainerStyles.bottomSection = {
    css: css`
        ${sectionStyles}
        align-items: center;
        ${xScreen("lte", "sm")} {
            flex-direction: column;
            gap: 16px;
            align-items: start;
        }
    `,
};

footerContainerStyles.logoWrapper = {
    css: css`
        display: flex;
        gap: 14px;
        align-items: center;

        ${xScreen("lte", "sm")} {
            flex-direction: column;
            gap: 16px;
            align-items: start;
        }
        .social-link {
            margin: 0;
        }
    `,
};

footerContainerStyles.logo = {
    css: css`
        border-right: 1px solid ${color("common.border")};
        padding-right: 16px;

        ${xScreen("lte", "sm")} {
            border-right: none;
            padding-right: 0;
        }

        .wrapper {
            width: 204px;
            height: 37px;
        }
    `,
};

footerContainerStyles.contentBlockWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        flex: 1;
        gap: 24px;
    `,
};

footerContainerStyles.linkListWrapper = {
    css: css`
        display: flex;
        flex: 1;
        gap: 22px;
        ${xScreen("lte", "md")} {
            gap: 20px;
        }
        ${xScreen("lte", "sm")} {
            gap: 16px;
            flex-wrap: wrap;
        }
    `,
};

footerContainerStyles.linkList = {
    css: css`
        flex: 1;
        ${xScreen("lte", "sm")} {
            flex: auto;
        }
        .title-wrapper {
            color: ${color("common.ui1")};
            font-size: 14px;
            line-height: 19px;
            margin-bottom: 8px;
            &:empty {
                display: none;
            }
        }
        .list-wrapper {
            padding: 0;
            text-transform: none;
        }
        .links-wrapper {
            font-size: 12px;
            line-height: 14px;
            padding: 0 0 12px;
            ${TypographyStyle} {
                color: ${color("common.ui1")};
                font-weight: normal;
            }
        }
    `,
};

footerContainerStyles.badges = {
    css: css`
        ${DivWrapper} {
            display: flex;
            gap: 16px;
            .img-wrapper {
                display: flex;
            }
        }
    `,
};

footerContainerStyles.copyRightWrapper = {
    css: css`
        display: flex;
    `,
};

footerContainerStyles.copyRight = {
    size: 12,
    lineHeight: "14px",
    color: "common.ui1",
    css: css`
        white-space: nowrap;
    `,
};

footerContainerStyles.siteMapLinksWrapper = {
    css: css`
        font-size: 12px;
        line-height: 14px;
        color: ${color("common.ui1")};
        ${xScreen("lte", "sm")} {
            width: 100%;
        }

        & > div {
            display: flex;
            ${xScreen("lte", "sm")} {
                gap: 6px;
                flex-direction: column;
                align-items: center;
            }
        }
        .list-wrapper {
            text-align: start;
            padding: 0;
            text-transform: none;
        }
        .links-wrapper {
            display: inline-block;
            padding: 0 14px 0 0;
            margin-right: 14px;
            &:last-child {
                margin-right: 0;
            }
            font-size: 12px;
            line-height: 14px;
            border-right: 1px solid ${color("common.ui1")};
            ${TypographyStyle} {
                color: ${color("common.ui1")};
                font-weight: normal;
            }
            &:last-child {
                border-right: none;
            }
        }
    `,
};
